export default {
  AnimalAssistanceFormField__DISCLAIMER:
    "Southwest Airlines does not carry emotional support animals.",
  AnimalAssistanceFormField__HEADER: "Service animal",
  AnimalAssistanceFormField__NOTE: "Note:",
  AnimalAssistanceFormField__SERVICE_ANIMAL: "Trained service dog - Documentation required",
};
